import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ClassroomManagerService } from 'src/lib/services/api/classroom-manager/classroom-manager.service';
import { ClassroomStudentModel } from 'src/lib/services/api/classroom-manager/models/classroom-student.model';
import { BehaviorCache } from 'src/lib/utilities/cache';

@Injectable({
	providedIn: 'root',
})
export class StudentClassroomStoreService {
	private _classroomCache = new BehaviorCache<number, ClassroomStudentModel>(
		(studentUid) =>
			this.classroomManagerService.getStudentClassroom(studentUid),
		'StudentClassroomStoreService ClassroomCache',
	);
	private _classroomsCache = new BehaviorCache<number, ClassroomStudentModel[]>(
		(studentUid) =>
			this.classroomManagerService.getStudentClassrooms(studentUid),
		'StudentClassroomStoreService ClassroomsCache',
	);

	constructor(private classroomManagerService: ClassroomManagerService) {}

	/**
	 * Classroom
	 */
	public classroom$ = (uid: number): Observable<ClassroomStudentModel> => {
		return this._classroomCache.getCache(uid).pipe(
			map((result) => {
				result.assert();
				return result.value;
			}),
		);
	};

	public refreshClassroom = (uid: number): Promise<boolean> => {
		return this._classroomCache.fetchData(uid, true);
	};

	public clearClassroom = (uid: number): void => {
		return this._classroomCache.clearData(uid);
	};

	/**
	 * Classrooms
	 */
	public classrooms$ = (uid: number): Observable<ClassroomStudentModel[]> => {
		return this._classroomsCache.getCache(uid).pipe(
			map((result) => {
				result.assert();
				return result.value;
			}),
		);
	};

	public refreshClassrooms = (uid: number): Promise<boolean> => {
		return this._classroomsCache.fetchData(uid, true);
	};

	public clearClassrooms = (uid: number): void => {
		return this._classroomsCache.clearData(uid);
	};
}
